<template>
    <div>
        <Navbar />
        <br>
        <div class="firstSectionContainer">
    <img class="polygon" :src="Polygon" alt="Polygon1" />
    <div class="titleContainer">
      <div class="imageContainer">
       <!-- <img class="img" :src="img" alt="img" />-->
       <h1 class="title">La solution PREXANGE</h1>
        <button class="signInBtn ">
          <Icon class="icon" icon="fluent:arrow-right-24-regular" height="20" />
          <span>Demande d’inscription</span>
        </button>
      </div>

    </div>
    <div class="textContainer">
    
      <p>Le projet PREXANGE est né d’une réflexion entre experts du courtage, de la banque et de l’ e-commerce.  </p>
      <p>L’idée est de créer un dispositif qui permet de remettre le client au centre des transactions et de respecter les réglementations en vigueur. La rencontre de deux mondes pour en créer un troisième.</p>
      <p>PREXANGE est une plateforme interconnectée permettant à tous les “acteurs” du crédit, depuis le client demandeur jusqu’aux collaborateurs bancaires, de se rencontrer sur une place de marché optimisée.</p>
    </div>
    
    <div class="btnContainerWithactions">
      <button class="actionButton">
        <Icon class="icon" icon="fluent:arrow-right-24-regular" height="24" />
        Comment ça marche ?
      </button>
      <button class="actionButtonSecandary">
        <span class="text1">
          Démarrer une collaboration
        </span>
        <span class="text2">
          Contact
        </span>
      </button>
    </div>
  </div>
  

  <div class="ThirdSectionContainer">
    <!-- 2 div left and right -->
    <div class="leftBox">
      <div class="imageContainer">
         <img class="leftBoxImage" :src="image" alt="image">
         <button class="signInBtn ">
        <Icon class="iconbtn" icon="fluent:arrow-right-24-regular" height="20" />
        Demander une démonstration
      </button>
      <Icon class="icon" icon="bi:play-btn" height="80" />
      </div>
    </div>
    <div class="rightBox">
      <div class="firstsection">
        <h1 class="title" style="display: inline-block; white-space: nowrap;">
            &nbsp;&nbsp;&nbsp;Nos missions&nbsp;&nbsp;&nbsp;
        </h1>
      </div>
      <div class="secondsection">
        <div class="card">
          <div>
          </div>
          <div>
            <span class="titlecard">
              
            </span>
            <P class="detailcard">
                Déploiement d’une solution digitale “pilotée” dans laquelle l’humain et sa satisfaction restent au coeur des préoccupations de chacun.
            </P>
          </div>
        </div>
        <div class="card">
          <div>
          </div>
          <div>
            <span class="titlecard">
              
            </span>
            <P class="detailcard">
              Mettre en conformité tout un pan du secteur de l’immobilier et des investissements faisant appel à un financement bancaire.
            </P>
          </div>
        </div>
        <div class="card">
          <div>
          </div>
          <div>
            <span class="titlecard">
              
            </span>
            <P class="detailcard">
              S’entourer des partenaires les plus innovants en matière de technologie.            </P>
          </div>
        </div>
        <div class="card">
          <div>
          </div>
          <div>
            <span class="titlecard">
              
            </span>
            <P class="detailcard">
                Accent mis sur l’efficience au travail; chacun devant pouvoir exercer son coeur de métier sans perte de temps.           </P>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="FourthSectionContainer">
        <div class="leftBox">
            <img class="leftBoxImage" :src="imageService" alt="image">
        </div>
        <div class="rightBox">
            <h1 class="title">
                L’équipe
            </h1>
            <div class="detail">
              <div class="row justify-content-center mt-4">
        <div class="col-sm-4">
            <div class="card">
              <img class="card-img-top" :src="imgJE" alt="Card image cap">
                <div class="card-body">
                    <h5 class="card-title">Jean-Emmanuel RHIE</h5>
                    <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                </div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="card">
              <img class="card-img-top" :src="imgProfil" alt="Card image cap">
                <div class="card-body">
                    <h5 class="card-title">Olivier LENDREVIE </h5>
                    <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                </div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="card">
              <img class="card-img-top" :src="imgProfil" alt="Card image cap">
                <div class="card-body">
                    <h5 class="card-title">Christophe DEBOSQUE</h5>
                    <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center mt-4">
        <div class="col-sm-4">
            <div class="card">
              <img class="card-img-top" :src="imgProfil" alt="Card image cap">
                <div class="card-body">
                    <h5 class="card-title">Arnaud BECQUART</h5>
                    <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                </div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="card">
              <img class="card-img-top" :src="imgGreg" alt="Card image cap">
                <div class="card-body">
                    <h5 class="card-title">Gregory FALCHERO</h5>
                    <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                </div>
            </div>
        </div>
        <div class="col-sm-4">
          <img class="card-img-top" :src="imgProfil" alt="Card image cap">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Afif KRAYEM</h5>
                    <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                </div>
            </div>
        </div>
    </div> 
            </div>
        </div>
    </div>
 
        <Footer id="footer"></Footer>
    </div>
</template>

<script>

import Navbar from './navbar/navbar.vue';
import Footer  from '@/components/footer.vue';
import Polygon from '@/assets/images/11305.jpg';
import img from '@/assets/images/prexange_services_1.png';
import image from '@/assets/images/bg3sec.png';
import imageService from '@/assets/images/prexange_apropos_img3.jpg';
import imageCatalogue from '@/assets/images/prexange3.jpg';
import image2 from '@/assets/images/se3box2.png';
import icon18 from '@/assets/images/suivi.png';
import icon19 from '@/assets/images/proposition.png';
import icon20 from '@/assets/images/pilotage.png';
import imgProfil from'@/assets/images/user.jpg';
import imgJE from'@/assets/images/JE.png';
import imgGreg from'@/assets/images/greg.jpeg';
import { Icon } from '@iconify/vue2';

export default {
    name: 'Home',
    components: {
        Navbar,
        Footer,
        Icon,
    },
    
  data() {
    return {
      Polygon: Polygon,
      img: img,
      isSidebarOpen: false,
      image: image,
      image2: image2,
      icon18: icon18,
      icon19: icon19,
      icon20: icon20,
      imageService: imageService,
      imageCatalogue: imageCatalogue,
      imgProfil: imgProfil,
      imgJE : imgJE,
      imgGreg: imgGreg
    };
  },
};
</script>

<style scoped>
.img {
 
  margin-left: 220px; /* Space between the image and text */
}

.sectionTwoContainer {
  background-image: url("../../../assets/images/prexange3.jpg");
}
</style>

<style lang="scss">
@import './firstScetion/firstSection.scss';
@import './ThirdSection/ThirdSection.scss';
@import './FourthSection/FourthSection.scss';
@import './SixthSection/SixthSection.scss';
@import './NosServices/nosservices.scss';
</style>

